import { render } from "./ContactUs.vue?vue&type=template&id=65818594&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=65818594&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65818594"]])

export default __exports__